import { TextArea } from 'devextreme-react';
import React, { useEffect, useState } from 'react';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import EventoVehiculo from '../../../01.-Domain/Entities/EventoVehiculo';
import Operacion from '../../../01.-Domain/Entities/Operacion';
import VehiculoGenerico from '../../../01.-Domain/Entities/VehiculoGenerico';
import { EstadoOperacionEnum } from '../../../01.-Domain/Enums/EstadoOperacionEnum';
import { EtapaEnum } from '../../../01.-Domain/Enums/EtapaEnum';
import { EventoEnum } from '../../../01.-Domain/Enums/EventoEnum';
import { default as toastService } from '../../../02.-Application/Services/Base/ToastService';
import { plantaService } from '../../../02.-Application/Services/PlantaService';
import SeguimientoService, { ObrasSeguimiento } from '../../../02.-Application/Services/SeguimientoService';
import VehiculoService from '../../../02.-Application/Services/VehiculoService';
import Grid from '../../Components/DataGrid/Grid';
import { columnas, columnasInicioFinExtendido } from './ColumnasVehiculos';

type Props = {
  show: boolean;
  cerrarPopup: () => void;
  cerrarSinCambios: () => void;
  extendido: EventoEnum;
};

/**
 * Si me envia las obras con todos sus viajes, puedo ver si alguna obra tiene un viaje en extendido
 * @param props
 * @returns
 */
const PopupRechazarCarga: React.FC<Props> = (props) => {
  const [vehiculos, setVehiculos] = useState<VehiculoGenerico[]>([]);
  const [vehiculoSeleccionado, setvehiculoSeleccionado] = useState<VehiculoGenerico>(null);
  const [obraSeleccionada, setObraSeleccionada] = useState<ObrasSeguimiento>(null);
  const [comentario, setComentario] = useState<string>('');
  const [btnDeshabilitado, setbtnDeshabilitado] = useState<boolean>(true);
  const [plantaIdOrigen, setPlantaIdOrigen] = useState<string>('');
  const [gridKey, setGridKey] = useState(0); // Nuevo estado para la key de los grids
  useEffect(() => {
    if (props.show) {
      // Limpiar estados al abrir el popup
      setvehiculoSeleccionado(null);
      setObraSeleccionada(null);
      setVehiculos([]); // Vaciar el grid de vehículos
      setComentario('');
      setbtnDeshabilitado(true);
      setGridKey((prevKey) => prevKey + 1); // Incrementar la key para forzar el re-render de los grids
    }
  }, [props.show]);
  useEffect(() => {
    if (!SeguimientoService.planificacionEnSeguimiento) {
      console.log('No hay planificacion en seguimiento');
      return;
    }

    setPlantaIdOrigen(plantaService.plantaActual.nombre);
    GetData();
  }, [obraSeleccionada]);

  function GetData() {
    setComentario('');

    // Obtener las operaciones de la obra seleccionada
    const operacionesDeObra = SeguimientoService.planificacionEnSeguimiento.operaciones.filter(
      (x: Operacion) => x.obraIdOrigen === obraSeleccionada?.idOrigen
    );

    const vehiculosObra: VehiculoGenerico[] = [];

    // Carga rechazada
    operacionesDeObra
      .filter(
        (x: Operacion) =>
          EstadoOperacionEnum[x.estado] === EstadoOperacionEnum.Iniciada &&
          (EtapaEnum[x.etapa] === EtapaEnum.Transporte || EtapaEnum[x.etapa] === EtapaEnum.Extendido)
      )
      .forEach((op: Operacion) => {
        if (!vehiculosObra.find((x: VehiculoGenerico) => x?.matricula === op.vehiculoGenerico?.matricula)) {
          if (op.vehiculoGenerico) {
            vehiculosObra.push(op.vehiculoGenerico);
          }
        }
      });

    setVehiculos(vehiculosObra);
  }

  async function RechazarCarga() {
    const evento = new EventoVehiculo(
      props.extendido,
      obraSeleccionada.idOrigen,
      comentario,
      plantaIdOrigen
    );

    await VehiculoService.InsertarEvento(vehiculoSeleccionado.matricula, evento)
      .then((result) => {
        if (result) {
          toastService.success('Evento insertado correctamente');
          GetData();
          props.cerrarPopup();
        } else {
          toastService.error('Ha habido un error insertando el evento');
        }
      })
      .catch(() => {
        toastService.error('Ha habido un error insertando el evento');
      });
  }

  const handleSelectionChange = (e: any) => {
    setvehiculoSeleccionado(e.selectedRowsData[0]);
    setbtnDeshabilitado(!vehiculoSeleccionado && !obraSeleccionada);
  };

  /**
   * Al seleccionar una obra, se muestran
   * @param e any
   * @returns
   */
  const handleObraChange = (e: any) => {
    setObraSeleccionada(e.selectedRowKeys[0]);
    setbtnDeshabilitado(!vehiculoSeleccionado && !obraSeleccionada);
  };

  const GridObraInicializado = (e: any) => {
    if (obraSeleccionada) {
      e.component.selectRows(obraSeleccionada, true);
    }
  };

  const GridVehiculoInicializado = (e: any) => {
    if (vehiculoSeleccionado) {
      e.component.selectRows(vehiculoSeleccionado, true);
    }
  };

  return (
    <Modal
      size="lg"
      onHide={() => props.cerrarSinCambios()}
      show={props.show}
      backdrop="static"
      keyboard={false}
      style={{ top: '3em' }}>
      <Modal.Header closeButton>
        <Modal.Title>Rechazar carga</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col>
            <Grid
              key={`obra-grid-${gridKey}`}
              altura={1600}
              showCheckBox="always"
              columns={columnasInicioFinExtendido}
              source={SeguimientoService.obras}
              editable={false}
              enableColumnChooser={false}
              summaryColumnCount="idOrigen"
              selectionChanged={handleObraChange}
              gridInitialized={GridObraInicializado}
              selectionMode="single"></Grid>
          </Col>
        </Row>
        <Row>
          <Col>
            <Grid
              key={`vehiculo-grid-${gridKey}`} // Añadir key al grid de vehículos
              altura={1600}
              showCheckBox="always"
              columns={columnas}
              source={vehiculos}
              editable={false}
              enableColumnChooser={false}
              summaryColumnCount="matricula"
              selectionChanged={handleSelectionChange}
              gridInitialized={GridVehiculoInicializado}
              selectionMode="single"
            />
          </Col>
        </Row>
        {props.extendido === EventoEnum.RechazarCarga && (
          <Row>
            <Col md={12}>
              <h3>Enviar Comentario</h3>
            </Col>
            <Col md={12}>
              <TextArea
                height={90}
                value={comentario}
                onValueChanged={(e: any) => setComentario(e.value)}
              />
            </Col>
          </Row>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={btnDeshabilitado} variant="primary" onClick={() => RechazarCarga()}>
          Rechazar carga
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PopupRechazarCarga;
